/** @jsx jsx */
import { DottedList, DottedListItem, Paragraph, TypeTimeReportIcon } from "@eworkit/iris";
import { FC, useContext } from "react";
import { useTranslation } from "react-i18next";
import { jsx } from "theme-ui";

import { DateRange } from "@/components/dates";
import { IconedHeader } from "@/components/headers/IconedHeader";
import { UserContext } from "@/components/User";
import { formatFullName } from "@/data/persons";
import { TimeReport } from "@/data/time-reports";

import { TimeReportStageStatus } from "../stages";

interface TimeReportHeaderProps {
  timeReport: TimeReport;
}

export const TimeReportHeader: FC<TimeReportHeaderProps> = ({ timeReport }) => {
  const { t } = useTranslation("session");

  const { hasCompanyManagerPrivileges } = useContext(UserContext);
  const isManager = hasCompanyManagerPrivileges();

  return (
    <IconedHeader
      icon={<TypeTimeReportIcon />}
      heading={<DateRange from={timeReport.startDate} to={timeReport.endDate} />}
      status={<TimeReportStageStatus stage={timeReport.stage.code} />}>
      <DottedList>
        <DottedListItem>
          <Paragraph color="n700">{timeReport.systemId}</Paragraph>
        </DottedListItem>

        <DottedListItem>
          <Paragraph color="n700">{t("TIME_REPORTS.LIST.VERSION", { version: timeReport.version + 1 })}</Paragraph>
        </DottedListItem>

        {isManager && (
          <DottedListItem>
            <Paragraph color="n700">{formatFullName(timeReport.worker)}</Paragraph>
          </DottedListItem>
        )}
      </DottedList>
    </IconedHeader>
  );
};
